import cmpConfig from '../cmp-config';

const logEnabled:boolean = cmpConfig.logging;

export interface ILog {
    debug: (msg: string, obj?: any) => void
}

const log: ILog = {
    debug: (msg:string, obj?:any): void => {
        if (logEnabled && console) {
            console.debug(`%cCMP 2.0`, 'background: #f54242; color: #ffffff; padding: 1px 4px; border-radius: 3px;', `${msg}`);
            if (obj) {
                console.table(obj);
            }
        }
    }
};

export {log};
